<div class="visits-widget-container">
  <div class="header">
    <div class="title">
       @if (hasVisitors && !demoUser) {{{'text_siteVisits' | dbText}}:
        {{ sumByDate }}
    } @else {
           {{'text_siteVisits' | dbText}}
       }
    </div>
    <ds-dropdown [smallSize]="true" [dsDropdownDisabled]="usedHostingVisitsByWebsite===0 || demoUser" [dsDropdownListWidth]="180"
                 [dsDropdownSmallFont]="true"
                 [dsDropdownOptions]="dropdownOptions"
                 [value]="activeMode" (onOptionChoose)="daysChanged($event)">
    </ds-dropdown>
  </div>
  @if (!hasVisitors || demoUser) {
    <div class="notif">
      {{'text_siteVisitsInfo' | dbText}}
    </div>
  } @else {
    <div class="body">
      <div class="chart-container">
        @for (day of days; track day.id; let i = $index) {
          <div class="bar-container"  (mouseout)="hoveredDayId = null" (mouseover)="hoveredDayId = day.id" [class.active]="mostVisitorsDayId === day.id && !hoveredDayId && hoveredDayId !== 0">
            <div class="bar" [class.zero]="!day.count"
                 [style.height.%]="getHeightPercent(day.count)">
              <div class="tooltip" [class.long]="day.count > 99" [class.left]="i <= (days.length/2)">
           <span>
             {{ day.date | date: 'd MMM' }}:
            <span class="count" [class.d-flex]="day.count > 99"
                  [innerHTML]="(day.count > 10000 ? roundNumbers(day.count, 'K', true) : day.count)+ ' ' + ('text_visitorsChart' | dbText)">

            </span>
            </span>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="chart-footer">
        <span>{{ endDate| date: 'd MMM y' }}</span>
        <span>{{ startDate| date: 'd MMM y' }}</span>
      </div>
    </div>
  }
</div>
